import {
  Icon,
  ICONS,
  Separator,
  RadioInput,
  Typography,
  TYPOGRAPHY_SIZE,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';
import { RadioChangeEvent } from 'antd';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IRightsListProps } from './rules-list-select.interfaces';
import { PLATFORM_RULES_VALUES } from './rules-list-select-constants';
import { MainContainer, TitleContainer, IconsContainer } from './rules-list-select.styles';

const RulesListSelect: FC<IRightsListProps> = ({
  selectedRule,
  permissionName,
  onRuleChange,
  isViewSeparator,
  onPermissionRemove,
}) => {
  const { t } = useTranslation(['common', 'settings']);
  const [isDone, setIsDone] = useState(false);
  const [rule, setRule] = useState(selectedRule);

  const onChangeRule = (event: RadioChangeEvent) => {
    setRule(event.target.value);
    onRuleChange(event.target.value);
  };

  return (
    <MainContainer>
      <TitleContainer>
        <Typography weight="bold">{permissionName}</Typography>
        {isDone && (
          <IconsContainer>
            <Icon
              icon={ICONS.pencil}
              color={PLATFORM_THEME_COLORS.primary.blue}
              size={16}
              onClick={() => setIsDone(false)}
            />
            <Icon
              icon={ICONS.trash}
              color={PLATFORM_THEME_COLORS.tone.red}
              size={16}
              className="icon"
              onClick={onPermissionRemove}
            />
          </IconsContainer>
        )}
      </TitleContainer>
      {isDone ? (
        <Typography
          size={TYPOGRAPHY_SIZE.xSmall}
          fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}
        >
          {rule && t(`settings:permissionGroupSettings.rules.${rule}`)}
        </Typography>
      ) : (
        <Typography
          size={TYPOGRAPHY_SIZE.xSmall}
          fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}
        >
          {t('settings:permissionGroupSettings.labels.selectRights')}
        </Typography>
      )}
      {!isDone && (
        <RadioInput.Group onChange={onChangeRule} value={rule}>
          {PLATFORM_RULES_VALUES.map(rule => (
            <RadioInput key={rule} value={rule} onClick={() => setIsDone(true)}>
              {t(`settings:permissionGroupSettings.rules.${rule}`)}
            </RadioInput>
          ))}
        </RadioInput.Group>
      )}
      {isViewSeparator && <Separator />}
    </MainContainer>
  );
};

export default RulesListSelect;
